import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { Text } from '@sitecore-jss/sitecore-jss-nextjs';
import { StNextImage } from '../shared/NextImage.styles';
import StErrorPageContainer from './ErrorPage.style';
import UiBox from '../../components/shared/Box';
import UiText from '../../components/shared/Typography/UiText';
import { JSSLink } from '../shared/Links/JSSLink.styles';
import RichTextUiHeading from '../../components/shared/RichTextHeading';

const ErrorPage = (props: any): any => {
  if (!props?.fields) return <></>;
  const buttonVariant = props?.fields?.buttonVariant;
  return (
    <StErrorPageContainer sx={{ minHeight: '100%' }}>
      <Box className="content">
        <Stack spacing={5} className="error-content-stack">
          <Box display="flex" justifyContent="center">
            <StNextImage
              suppressHydrationWarning
              data-testid="icon"
              field={props.fields.icon}
              width={97}
              height={87}
            />
          </Box>

          <UiBox>
            <RichTextUiHeading size="h3" color="primary" align="center" data-testid="header">
              {props.fields.content}
            </RichTextUiHeading>
          </UiBox>

          <Grid>
            <UiText size="body" color="black" className="sub-content" data-testid="sub-header">
              <Text field={props.fields.subContent} />
            </UiText>
          </Grid>

          <Box className="back-btn">
            <JSSLink
              field={{
                value: {
                  href: props?.fields?.link?.value?.href,
                  text: props?.fields?.link?.value?.text,
                },
              }}
              className="error-back-btn"
              variant={buttonVariant?.value || 'contained'}
              aria-label={props?.fields?.ariaLabel?.value}
              data-testid="back-button"
              tabIndex={0}
            />
          </Box>
        </Stack>
      </Box>
    </StErrorPageContainer>
  );
};

export default ErrorPage;
